<div class="{{showTaskComponent ? 'hidden' : 'full-height-container'}}">
  <mat-card class="full-height-container">
    <mat-card-content class="full-height-container content-panel">
      <div class="flex-row">
        <app-component-header (downloadClickEvent)="this.handleDownloadClickEvent('client-portal-users')"
                              (refreshClickEvent)="this.refreshView()"
                              [checkAutoRefreshByDefault]="false"
                              [hideColumnsButton]="true"
                              [hideUploadButton]="true"
                              [startRefreshTimer]="this.refreshComplete"
                              [subtitleSegments]="getUrlSegments()"
                              class="full-width">
        </app-component-header>
      </div>
      <div class="flex-row table-container">
        <ag-kpi-sidebar [sidebar]="kpiSidebar" class="mg-r-s"></ag-kpi-sidebar>
        <ag-grid-angular
          (columnVisible)="onColumnVisible($event)"
          (filterChanged)="onFilterChanged($event)"
          (firstDataRendered)="onFirstDataRendered($event)"
          (gridReady)="onGridReady($event)"
          (selectionChanged)="onRowSelectionChanged($event)"
          (viewportChanged)="onViewportChanged($event)"
          [columnDefs]="tableColumns"
          [getRowId]="getRowIdFn"
          [gridOptions]="baseAgGridOptions"
          [groupHideOpenParents]="false"
          [overlayNoRowsTemplate]="noRowsTemplate"
          [rowData]="rowData"
          [rowGroupPanelShow]="'always'"
          [suppressPropertyNamesCheck]="true"
          class="ag-theme-quartz ag-grid-flex">
        </ag-grid-angular>
        <ng-template #footerActionButtonPanel>
          <button (click)="onBulkProcessClicked()" [disabled]="!isBulkOperationAllowed" color="primary" mat-raised-button>
            <i class="fa-sharp fa-light fa-id-card"></i>
            Bulk License / Un-license
          </button>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="{{showTaskComponent ? 'full-height-container': 'hidden' }}">
  <app-user-list-task (goBackEvent)="goBack()" *ngIf="showTaskComponent" [selectedFeatureMode]="selectedFeatureMode" [selectedRows]="this.selectedRows"/>
</div>
